import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

import aboutHero from "../assets/habarana1.jpg";

import sigiriyaImg from "../assets/Sigiriya.jpg";
import pidurangalaImg from "../assets/Pidurangala.jpg";
import minneriyaImg from "../assets/Minneriya_National_Park.jpg";
import ritigalaImg from "../assets/ritigala.jpg";
import villageSafariImg from "../assets/village-safari.jpg";
import kaudullaImg from "../assets/kaudulla-safari.jpg";
import habaranaLakeImg from "../assets/habarana-lake.jpg";

function Explore() {

    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[60vh] w-full">
                <img
                    src={aboutHero}
                    alt="Habarana"
                    className="absolute inset-0 w-full h-full object-fixed"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1
                        data-aos="fade-up"
                        className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3"
                    >
                        Explore Habarana
                    </h1>
                </div>
            </section>

            {/* ================= EXPLORE SECTION ================= */}
            <section className="py-16 bg-[#f6f4f1] px-4 md:px-10">

                {/* Section Heading */}
                <div className="max-w-6xl mx-auto text-center mb-20">
                    <h2 className="text-3xl md:text-4xl font-semibold mb-4">
                        Discover the Beauty of Habarana
                    </h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Habarana is the perfect gateway to Sri Lanka’s Cultural Triangle.
                        Experience wildlife safaris, peaceful lakes, ancient ruins, and
                        breathtaking natural landscapes all within a short distance.
                    </p>
                </div>

                {/* ===== SIGIRIYA ===== */}
                <div className="relative max-w-6xl mx-auto mb-20">
                    <div className="grid md:grid-cols-2 items-center">

                        <div className="bg-[#e9e2d9] p-12 md:p-16 z-10">
                            <h3 className="text-2xl md:text-3xl font-medium mb-6">
                                Sigiriya Rock Fortress
                            </h3>

                            <p className="text-gray-700 mb-8 leading-relaxed">
                                Discover the ancient marvel of Sigiriya, a UNESCO World Heritage
                                Site known as the Lion Rock. Climb to the top to witness stunning
                                panoramic views, beautiful fresco paintings, and the remarkable
                                ruins of King Kashyapa's royal palace.
                            </p>

                            <button
                                onClick={() => navigate("/explore/sigiriya")}
                                className="mt-10 border-b border-black pb-1 tracking-wider text-sm hover:text-[#c97b3a] transition">
                                EXPLORE SIGIRIYA —
                            </button>
                        </div>

                        <div className="relative md:-ml-16 mt-10 md:mt-0">
                            <img
                                src={sigiriyaImg}
                                alt="Sigiriya Rock"
                                className="w-full h-[450px] object-cover shadow-xl"
                            />
                        </div>

                    </div>
                </div>

                {/* ===== PIDURANGALA ===== */}
                <div className="relative max-w-6xl mx-auto mb-20">
                    <div className="grid md:grid-cols-2 items-center">

                        <div className="relative md:-mr-16 order-2 md:order-1 mt-10 md:mt-0">
                            <img
                                src={pidurangalaImg}
                                alt="Pidurangala Rock"
                                className="w-full h-[450px] object-cover shadow-xl"
                            />
                        </div>

                        <div className="bg-[#e9e2d9] p-12 md:p-16 order-1 md:order-2 z-10">
                            <h3 className="text-2xl md:text-3xl font-medium mb-6">
                                Pidurangala Rock
                            </h3>

                            <p className="text-gray-700 mb-8 leading-relaxed">
                                A popular hiking destination near Sigiriya, Pidurangala Rock
                                offers one of the most breathtaking sunrise and sunset views in
                                Sri Lanka. From the summit, visitors can enjoy an incredible
                                panoramic view of the iconic Sigiriya Rock.
                            </p>

                            <button
                                onClick={() => navigate("/explore/pidurangala-rock")}
                                className="mt-10 border-b border-black pb-1 tracking-wider text-sm hover:text-[#c97b3a] transition">
                                DISCOVER THE VIEW —
                            </button>
                        </div>

                    </div>
                </div>

                {/* ===== MINNERIYA ===== */}
                <div className="relative max-w-6xl mx-auto mb-20">
                    <div className="grid md:grid-cols-2 items-center">

                        <div className="bg-[#e9e2d9] p-12 md:p-16 z-10">
                            <h3 className="text-2xl md:text-3xl font-medium mb-6">
                                Minneriya Elephant Gathering
                            </h3>

                            <p className="text-gray-700 mb-8 leading-relaxed">
                                Witness one of the largest gatherings of wild elephants in the
                                world at Minneriya National Park. During the dry season, hundreds
                                of elephants gather around the Minneriya reservoir, creating an
                                unforgettable wildlife spectacle.
                            </p>

                            <button
                                onClick={() => navigate("/explore/minneriya-national-park")}
                                className="mt-10 border-b border-black pb-1 tracking-wider text-sm hover:text-[#c97b3a] transition">
                                GO ON SAFARI —
                            </button>
                        </div>

                        <div className="relative md:-ml-16 mt-10 md:mt-0">
                            <img
                                src={minneriyaImg}
                                alt="Minneriya Safari"
                                className="w-full h-[450px] object-cover shadow-xl"
                            />
                        </div>

                    </div>
                </div>

                {/* ===== RITIGALA ===== */}
                <div className="relative max-w-6xl mx-auto mb-20">
                    <div className="grid md:grid-cols-2 items-center">

                        <div className="relative md:-mr-16 order-2 md:order-1 mt-10 md:mt-0">
                            <img
                                src={ritigalaImg}
                                alt="Ritigala Forest Monastery"
                                className="w-full h-[450px] object-cover shadow-xl"
                            />
                        </div>

                        <div className="bg-[#e9e2d9] p-12 md:p-16 order-1 md:order-2 z-10">
                            <h3 className="text-2xl md:text-3xl font-medium mb-6">
                                Ritigala Forest Monastery
                            </h3>

                            <p className="text-gray-700 mb-8 leading-relaxed">
                                Hidden within a lush jungle, Ritigala is an ancient Buddhist
                                monastery known for its peaceful atmosphere and mysterious
                                ruins. Walk through forest paths surrounded by nature and
                                explore one of Sri Lanka’s most serene historical sites.
                            </p>

                            <button
                                onClick={() => navigate("/explore/ritigala")}
                                className="mt-10 border-b border-black pb-1 tracking-wider text-sm hover:text-[#c97b3a] transition">
                                EXPLORE HISTORY —
                            </button>
                        </div>

                    </div>
                </div>

                {/* ===== HABARANA VILLAGE SAFARI ===== */}
                <div className="relative max-w-6xl mx-auto mb-20">
                    <div className="grid md:grid-cols-2 items-center">

                        {/* LEFT TEXT */}
                        <div className="bg-[#e9e2d9] p-12 md:p-16 z-10">
                            <h3 className="text-2xl md:text-3xl font-medium mb-6">
                                Habarana Village Safari
                            </h3>

                            <p className="text-gray-700 mb-8 leading-relaxed">
                                Experience the authentic rural lifestyle of Sri Lanka with the
                                Habarana Village Safari. Ride a traditional bullock cart through
                                scenic village paths, cross the lake on a catamaran boat, and
                                visit a local village home to enjoy freshly prepared Sri Lankan
                                food and traditional cooking demonstrations.
                            </p>

                            <button
                                onClick={() => navigate("/explore/habarana-village-safari")}
                                className="mt-10 border-b border-black pb-1 tracking-wider text-sm hover:text-[#c97b3a] transition">
                                EXPERIENCE VILLAGE LIFE —
                            </button>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="relative md:-ml-16 mt-10 md:mt-0">
                            <img
                                src={villageSafariImg}
                                alt="Habarana Village Safari"
                                className="w-full h-[450px] object-cover shadow-xl"
                            />
                        </div>

                    </div>
                </div>

                {/* ===== KAUDULLA NATIONAL PARK ===== */}
                <div className="relative max-w-6xl mx-auto mb-20">
                    <div className="grid md:grid-cols-2 items-center">

                        {/* IMAGE LEFT */}
                        <div className="relative md:-mr-16 order-2 md:order-1 mt-10 md:mt-0">
                            <img
                                src={kaudullaImg}
                                alt="Kaudulla National Park Safari"
                                className="w-full h-[450px] object-cover shadow-xl"
                            />
                        </div>

                        {/* TEXT RIGHT */}
                        <div className="bg-[#e9e2d9] p-12 md:p-16 order-1 md:order-2 z-10">
                            <h3 className="text-2xl md:text-3xl font-medium mb-6">
                                Kaudulla National Park Safari
                            </h3>

                            <p className="text-gray-700 mb-8 leading-relaxed">
                                Embark on an exciting wildlife safari at Kaudulla National Park,
                                known for its large herds of wild elephants and rich biodiversity.
                                The park is also home to deer, monkeys, birds, and many other
                                fascinating species living freely in their natural habitat.
                            </p>

                            <button
                                onClick={() => navigate("/explore/kaudulla-national-park")}
                                className="mt-10 border-b border-black pb-1 tracking-wider text-sm hover:text-[#c97b3a] transition">
                                START YOUR SAFARI —
                            </button>
                        </div>

                    </div>
                </div>

                {/* ===== HABARANA LAKE ===== */}
                <div className="relative max-w-6xl mx-auto">
                    <div className="grid md:grid-cols-2 items-center">

                        {/* LEFT TEXT */}
                        <div className="bg-[#e9e2d9] p-12 md:p-16 z-10">
                            <h3 className="text-2xl md:text-3xl font-medium mb-6">
                                Habarana Lake
                            </h3>

                            <p className="text-gray-700 mb-8 leading-relaxed">
                                Surrounded by lush greenery and peaceful nature, Habarana Lake
                                offers a relaxing escape for visitors. Enjoy traditional boat
                                rides across the calm waters, watch beautiful sunsets, and
                                observe a variety of birds and wildlife that gather around
                                this scenic lake.
                            </p>

                            <button
                                onClick={() => navigate("/explore/habarana-lake")}
                                className="mt-10 border-b border-black pb-1 tracking-wider text-sm hover:text-[#c97b3a] transition">
                                ENJOY THE VIEW —
                            </button>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="relative md:-ml-16 mt-10 md:mt-0">
                            <img
                                src={habaranaLakeImg}
                                alt="Habarana Lake"
                                className="w-full h-[450px] object-cover shadow-xl"
                            />
                        </div>

                    </div>
                </div>

            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94764806045?text=Hello!%20I%20would%20like%20more%20information%20about%20exploring%20Habarana."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>

        </div>
    );
}

export default Explore;